export default __webpack_public_path__ + "static/media/cat.0ba76095.svg";